import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OtherService } from "src/app/Service/other.service";
import { map, Observable, of } from 'rxjs';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import axios from "src/app/Service/axios";

@Component({

  selector: 'app-taxi-dashboard',

  templateUrl: './taxi-dashboard.component.html',

  styleUrls: ['./taxi-dashboard.component.css']

})

export class TaxiDashboardComponent implements OnInit {

  options!: Observable<any>;

  options1!: Observable<any>;

  lst_BestTaxies = [];

  lst_BadTaxies = [];

  constructor(

    private router: Router,

    private deviceDetector: DeviceDetectorService,

    private otherService: OtherService,

    private gurdService: GurdServiceService,

    private _tooltip: NotificationService,

  ) { }

  ngOnInit(): void {

    this.loadTree1('Taxi_FleetsBaseLine');

    this.get_BestTaxies();

    this.get_BadTaxies();

    this.loadTree2('Taxi_AverageLife');


  }

  loadTree1 = async (api: any) => {

    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };

    this.otherService.Showspinner();

    const resp = await axios.post(`${api}`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    this.options = of(resp.data).pipe(map((data: any) => {

      let res = JSON.parse(data.toString());

      let not = 0;

      res.children.forEach((element: any) => {

        not += element.children.length

      });

      if (not > 50) {

        let can = document.getElementById('totalVehicles') as HTMLElement;

        can.style.height = '700px'

      }

      res.children.forEach(function (datum: any, index: number) {

        index % 1 === 0 && (datum.collapsed = true);

      });

      return {
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove',
          responsive: true,
          textStyle: {
            color: '#000',
            fontFamily: 'vazir',
            fontSize: 12
          },
          formatter: function (params: any) {
            return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
          }
        },
        series: [
          {
            type: 'tree',
            data: [res],
            top: '1%',
            left: '10%',
            responsive: true,
            bottom: '5%',
            right: '20%',
            symbolSize: 10,
            label: {
              position: 'left',
              fontFamily: 'vazir',
              verticalAlign: 'middle',
              align: 'right',
              fontSize: 12,
              fontWeight: 600,
              color: '#000',
            },
            leaves: {
              label: {
                position: 'right',
                verticalAlign: 'middle',
                align: 'left',
                color: '#000'
              },
            },
            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750,
          },
        ],
      };
    }),
    );

  }

  async get_BestTaxies() {

    var model = this.otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    });

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Taxi_BestTaxiesInLastMounth`, model)).data.toString());

    this.otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_BestTaxies = res;


  }

  async get_BadTaxies() {

    var model = this.otherService.stringNumberToNumber({

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    });

    this.otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Taxi_BadTaxiesInLastMounth`, model)).data.toString());

    this.otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_BadTaxies = res;


  }

  loadTree2 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };
    this.otherService.Showspinner();
    const resp = await axios.post(`${api}`, model);
    this.otherService.nonespinner();
    this.options1 = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('orgVehiclesStatus') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

}
